import React from 'react';
import classNames from 'classnames';

import enhanceInfoItem from './enhanceInfoItem';
import styles from './InfoItem.scss';


type Item = {
  id: number,
  title: string,
}

type Props = {
  title: string,
  items: Array<Item>,
  className: string,
};

const InfoItem = ({ title, items, className }: Props) => (<div className={classNames(styles.root, className)}>
  <div>
    {title}
      &nbsp;&nbsp;
    <span className={styles.num}>{items.length}</span>
  </div>
  <div className={styles.list}>
    {items.map(item => <div key={item.id}>{item.title}</div>)}
  </div>
</div>);

export default enhanceInfoItem(InfoItem);
